import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { devicesApi } from '@/api/index';

export const fetchDevicesIds = createAsyncThunk(
  'devicesIds',
  async (params, thunkAPI) => {
    try {
      const response = await devicesApi.getIds();
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
